export const UPDATE_AUTH = "UPDATE_AUTH";

export const updateAuth = (value) => ({
  type: UPDATE_AUTH,
  value,
});
